import clsx from 'clsx'

export type PerSessionLabelColor = 'sand' | 'sand-dark' | 'mint-50' | 'orange-25' | 'lavender-50'

interface PerSessionSummaryProps {
  label: string
  labelColor: PerSessionLabelColor
  perSessionAmount: string
}

const LABEL_COLOR_CLASS: Record<PerSessionLabelColor, string> = {
  sand: 'bg-sand',
  'sand-dark': 'bg-sand-dark',
  'mint-50': 'bg-mint-50',
  'orange-25': 'bg-orange-25',
  'lavender-50': 'bg-lavender-50',
}

export function PerSessionSummary({ label, labelColor, perSessionAmount }: PerSessionSummaryProps) {
  return (
    <div className="grid gap-2 p-4 text-center">
      <span>
        <span
          className={clsx(
            'py-1 px-2 rounded-2xl inline-block text-sm font-medium',
            LABEL_COLOR_CLASS[labelColor]
          )}
        >
          {label}
        </span>
      </span>
      <div>
        <span className="font-medium text-2xl">{perSessionAmount}</span>
        <span className="text-sm text-charcoal-50">/session</span>
      </div>
    </div>
  )
}
